/**
 * File: OrderPage.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.0
 * Created: 2026-04-25
 * Last Updated: 2026-07-25
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useEffect, useState } from "react";

// Local project files
import { fetchOrderData } from "../utils/ServiceRequests";
import StatCard from "../components/ui/StatCard";
import TableLayout from "../components/layout/TableLayout";

/**
 * [TODO: Component description here]
 *
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function OrderPage({ schema }) {
    const [tableView, setTableView] = useState("estimates-table");

    const [estimateRows, setEstimateRows] = useState([]);
    const [workOrderRows, setWorkOrderRows] = useState([]);
    const [invoiceRows, setInvoiceRows] = useState([]);

    useEffect(() => {
        const fetchTableRows = async () => {
            try {
                const orderData = await fetchOrderData();

                setEstimateRows(orderData.data.estimates);
                setWorkOrderRows(orderData.data.workOrders);
                setInvoiceRows(orderData.data.invoices);
            } catch (error) {
                console.log(error);
            }
        };

        fetchTableRows();
    }, []);

    const tableConfig = {
        "estimates-table": "estimatesTable",
        "work-orders-table": "workOrdersTable",
        "invoices-table": "invoicesTable",
    };

    const tableKey = tableConfig[tableView];
    const tableStats = schema.statCards[tableKey];
    const tableSchema = schema.tableLayout[tableKey];

    let tableRows = [];
    let setTableRows = null;

    if (tableView === "estimates-table") {
        tableRows = estimateRows;
        setTableRows = (rows) => setEstimateRows(rows);
    } else if (tableView === "work-orders-table") {
        tableRows = workOrderRows;
        setTableRows = (rows) => setWorkOrderRows(rows);
    } else if (tableView === "invoices-table") {
        tableRows = invoiceRows;
        setTableRows = (rows) => setInvoiceRows(rows);
    }

    return (
        <>
            <div className="order-page">
                <div className="order-page__container">
                    <div className="order-page__stat-cards">
                        {tableStats.map((stat) => (
                            <StatCard
                                key={stat.id}
                                label={stat.label}
                                value={stat.value(tableRows)}
                            />
                        ))}
                    </div>
                    <TableLayout
                        schema={tableSchema}
                        tableRows={tableRows}
                        setTableRows={setTableRows}
                        setTableView={setTableView}
                    />
                </div>
            </div>
        </>
    );
}

export default OrderPage;
